import React from "react";
import R14, {
  Form,
  View,
  StyleSheet,
  SelectMenuField,
  TextInputField,
  Button,
  SubmitButton,
} from "../core";
import { commonStyles } from "../assets/css/commonStyle";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import CommonValidators from "../utils/CommonValidators";
import { customCommonStyles } from "../assets/css/customCommonStyle";
import { CommonString } from "../constant/appCommonText";
import { MESSAGE_TYPE } from "../constant/app.data.constant";
import PopupModalComponent from "../components/PopupModalComponent";
import ChatboxInputField from "../components/ChatboxInputField";

export default R14.connect(
  class CreatingMessageScreen extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isAddAttachmentsVisible: false,
        attachments: [],
        isDisable: false,
        isErrorPopUp: false,
        errorPopUpMessage: "",
        senderPid: props.senderPid,
        leftMenuToggle: props.leftMenuToggle,
        isMobileDevice: props.isMobileDevice
      };
      this.form = this.props.app.ui.form("creatingMessage");
    }

    componentDidMount()
    {
      this.form = this.props.app.ui.form("creatingMessage");
    }

    alertOk = async () => {
      this.setState({
        isErrorPopUp: false,
        errorPopUpMessage: ''
      })
    };

    renderAlertPopup() {
      const { isErrorPopUp, errorPopUpMessage } = this.state;
      return (
        <PopupModalComponent
          visibility={isErrorPopUp}
          bodyWrapper={[commonStyles.smallModalBodyWrapper]}
          messageType={MESSAGE_TYPE.error}
          headingIcon={true}
          heading={"Error"}
          modalContent={[commonStyles.marginTop10, commonStyles.marginBottom10]}
          bodyContent={errorPopUpMessage}
          okLabel={"Ok"}
          handleOk={() => this.alertOk(errorPopUpMessage)}
          closeLabel={""}
          handleClose={null}
        />
      );
    }

    openAttachments = async () => {
      const { attachments } = this.state;
      if(attachments && attachments.length){
        this.setState({
          isErrorPopUp: true,
          errorPopUpMessage: "Maximum 1 attachment allowed.",
        });
      } else {
        this.setState({
          isAddAttachmentsVisible: !this.state.isAddAttachmentsVisible,
        });
      }
    };

    closeAttachmentModal = () => {
      this.setState({
        isAddAttachmentsVisible: false,
      });
    };

    handleSubmit = async (form) => {
      this.setState({ isDisable: true });
      try {
        const { billerName, subject, messageBody } = form.values;
        const { attachments } = this.state;
        let biller = await this.props.app.dm.rest.billerBUdetails(billerName.value);
        const data = {
          subject,
          messageBody,
          recipientName: billerName.label,
          attachments: !!attachments.length ? attachments : null,
        };
        let rtpPayload = await this.props.app.dm.simpleMessage.getMessagePayload({...data, ...biller});
        let res = await this.props.app.dm.simpleMessage.postSimpleMessage(rtpPayload);
        if (res && !!res.threadId) {
          this.props.app.dm.commonDomain.showToastr("success", CommonString.MessageSent);
          this.props.app.nav.to("simpleMessageRoute");
          return true;
        } else {
          this.props.app.dm.commonDomain.showToastr("error", CommonString.MessageFail);
          this.setState({ isDisable: false });
        }
      } catch (error) {
        this.props.app.dm.commonDomain.showToastr("error", error);
        this.setState({ isDisable: false });
      } finally {
        return false;
      }
    };

    onFileInputChange = async (val) => {
      let x = [val];
      const { attachments } = this.state;
      if (attachments.length > 0) {
        this.props.app.dm.commonDomain.showToastr("error","Maximum 1 attachment allowed.");
        return false;
      }
      this.setState({ isAddAttachmentsVisible: false, attachments: [...attachments, ...x] });
    };

    onDeleteFile = (ind) => {
      const { attachments } = this.state;
      this.setState({
        attachments: attachments.filter((value, index, arr) => index !== ind),
      });
    };

    onBillerPid = (val) => {
      const { label, value } = val;
      if (label === "No Results Found" || label.includes("Type in a search value")) {
        this.form.elmts.billerName.setValue(null);
      } else {
        this.form.elmts.billerName.setValue({ label: value, value: label });
      }
      this.form.elmts.billerName.setError(null);      
      this.form.elmts.subject.setValue(null);
      this.form.elmts.messageBody.setValue(null);
    };

    onBillerName = (val) => {
      const { label, value } = val;
      this.form = this.props.app.ui.form("creatingMessage");
      if (label === "No Results Found" || label.includes("Type in a search value")) {
        this.form.elmts.billerName.setValue(null);
      } else {
        this.form.elmts.billerName.setValue({ label: label, value: value });
      }
      this.form.elmts.billerName.setError(null);
      this.form.elmts.subject.setValue(null);
      this.form.elmts.subject.setError(null);
      this.form.elmts.messageBody.setValue(null);
      this.form.elmts.messageBody.setError(null);
    };

    onCancel = () => {
      this.props.app.nav.to("simpleMessageRoute");
    };

    readText = (val) => {
      if ((!val && !!this.form) || val.length <= 140) {
        this.form.elmts.messageBody.setError(null);
      } else if (val.length > 140) {
        this.form.elmts.messageBody.setError(CommonString.ContentExceed140);
      }
    };

    readTextForSubject = (val) => {
      if ((!val && !!this.form) || val.length <= 140) {
        this.form.elmts.subject.setError(null);
      } else if (val.length > 140) {
        this.form.elmts.subject.setError(CommonString.ContentExceed140);
      }
    };

    render() {
      const { senderPid, isMobileDevice } = this.state;

      let { billerNameList } = this.props;
      return (
        <>
            <View style={[commonStyles.flex1, commonStyles.flexGrow1,  styles.creatingMessageScreenInnerWrap, commonStyles.pageBorderRadius5]}>
            <Form
              name="creatingMessage"
              style={[commonStyles.flex0, commonStyles.flexGrow0, isMobileDevice ? styles.createMessageForm : null, styles.customCreateMessageForm]}
              validateBeforeSubmit={true}
              validators={CommonValidators.getFormValidator()}
                onSubmit={this.handleSubmit}>
                <View style={[commonStyles.flex1, commonStyles.customFlexDirection]}>
                <View style={[styles.leftInputField]}>
                  <SelectMenuField
                    style={[commonFontStyles.workSans, commonStyles.heading6, commonStyles.marginBottom25]}
                    labelTextStyle={[commonStyles.labelText,commonFontStyles.workSans, commonStyles.heading6]}
                    name="billerName"
                    label={CommonString.BillerBULabel + "*"}
                    required={CommonString.SelectBillerBURequired}
                    items={billerNameList}
                    onValueChange={this.onBillerName}
                    searchable
                    itemLoader={async ({ search }) => {
                      let items = billerNameList;
                      return items
                        .filter((item) => {
                          return item.label.toLowerCase().includes(search.toLowerCase());
                        })
                        .sort((a, b) => b.label - a.label);
                    }}
                    disabled={senderPid ? true : false}
                    labelStyle={[commonStyles.formLabelStyle, customCommonStyles.inputLableStyle,customCommonStyles.selectMenuInputLabelStyle]}
                    helperTextStyle={[styles.customHelperTextStyle, commonStyles.helperTextFontStyle, commonFontStyles.workSans]}
                  />
                </View>
                <View style={[styles.rightInputField]}>
                  <TextInputField
                    name="subject"
                    label={CommonString.SubjectLabel + "*"}
                    required={CommonString.EnterSubjectRequired}
                    validator="cmtsVali"
                    onChangeText={this.readTextForSubject}
                    style={[commonFontStyles.workSans, commonStyles.heading6, customCommonStyles.inputHeight]}
                    labelTextStyle={[commonStyles.labelText, commonFontStyles.workSans, commonStyles.heading6]}
                    labelStyle={[commonStyles.formLabelStyle, customCommonStyles.inputLableStyle]}
                    helperTextStyle={[styles.customHelperTextStyle, commonStyles.helperTextFontStyle, commonFontStyles.workSans]}
                  />
                </View>
              </View>
              <View>
                <ChatboxInputField
                  name="messageBody"
                  label={`${CommonString.EnterMessageLabel}*`}
                  required={CommonString.EnterMessageRequired}
                  multiline
                  validator="cmtsVali"
                  onValueChange={this.onFileInputChange}
                  onChangeText={this.readText}
                  deleteFile = {this.onDeleteFile}
                />
              </View>
              <View style={[commonStyles.marTAuto, commonStyles.flex1, styles.formBtns, customCommonStyles.createMessageFormBtn]}>
                <View style={[styles.formBtnsHolder, commonStyles.marginRight10]}>
                  <Button
                    title={"Cancel"}
                    style={[commonStyles.blueBorderButton, commonStyles.fullWidth, customCommonStyles.noBoxShadow, commonStyles.btnHeight24]}
                    titleTextStyle={[
                      commonStyles.blueBorderButtonColor,
                      commonStyles.fontWeight500,
                      commonFontStyles.workSans,
                      commonStyles.exSmallHeading,
                    ]}
                    onPress={this.onCancel}
                  />
                </View>
                <View style={[styles.formBtnsHolder, commonStyles.marginLeft10]}>
                  <SubmitButton
                    title={"Submit"}
                      style={[commonStyles.blueButton, commonStyles.fullWidth, customCommonStyles.noBoxShadow, commonStyles.btnHeight24]}
                    titleTextStyle={[commonStyles.whiteColor, commonStyles.fontWeight500, commonFontStyles.workSans, commonStyles.exSmallHeading]}
                  />
                </View>
              </View>
            </Form>
            </View>
            {this.renderAlertPopup()}
          </>
      );
    }
  }
);
const styles = StyleSheet.create({
  creatingMessageScreenInnerWrap: {
    backgroundColor: "#fff",
    marginRight: 16,
    marginBottom: 16,
    marginLeft: 16,
    borderWidth: 1,
    borderColor: "#e2e2e2",
    borderStyle: "solid",
    screen: ({ width }) => {
      if (width <= 991)
      return {
          marginRight: 0,
          marginBottom: 0,
          marginLeft: 0,
        };
    },
  },
  commentsField: {
    minHeight: 128,
    maxHeight: 128,
    resize: "none",
    lineHeight: 15,
    paddingTop: 5,
  },
  leftInputField: {
    flexBasis: "50%",
    marginRight: 8,
    maxWidth: "50%", 
    screen: ({ width }) => {
      if (width <= 991)
      return {
        flexBasis: "100%",
        marginRight: 0,
        maxWidth: "100%", 
        };
    },
  },
  rightInputField: {
    flexBasis: "50%",
    marginLeft: 8,
    screen: ({ width }) => {
      if (width <= 991)
        return {
          flexBasis: "100%",
          marginLeft: 0,
          marginTop: 5,
        };
    },
  },
  formBtns: {
    justifyContent: "flex-end",
    flexDirection: "row",
    screen: ({ width }) => {
      if (width <= 991)
        return {
          justifyContent: "center",
        };
    },
  },
  formBtnsHolder: {
    screen: ({ width }) => {
      if (width <= 991)
        return {
          flexBasis: "50%",
        };
    },
  },
  createMessageForm: {
    marginBottom: 60,
  },
  customHelperTextStyle: {
    left: 0,
  },
  attachmentFieldOuterCustomHeight: {
    position: "relative",
    height: 60,
    minWidth: 55,
  },
  customCreateMessageForm: {
    display: "block",
    overflowX: "auto",
  },
  addattachmentBtnWrap: {
    backgroundColor: "rgb(224, 224, 224)",
    padding: 5,
    borderRadius: "100%",
  },
  top15: {
    top: 15
  }
});
